import { styled } from '@mui/material';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
